import { Suspense, lazy } from "react";

import { BillboardPageContent } from "pages/[tenant]/browse/components/BillboardPage/styles";
import useBrowsePageService from "pages/[tenant]/browse/hooks/useBrowsePageService";
import { ISectionContent } from "pages/[tenant]/browse/types";
import { getDownContentLoadingSkeleton } from "pages/[tenant]/browse/utils/getDownContentLoadingSkeleton";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import InfinityScroll from "shared/components/atoms/InfinityScroll";
import { IBillboardHighlight, IBillboardSection } from "shared/types/billboard";
import componentLoader from "shared/utils/componentLoader";

const Carousel = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunckName: 'Carousel', filename: 'Carousel' */
        "../Carousel"
      ),
  ),
);

interface IDownContentProps {
  sectionContent: ISectionContent[][];
  sections: IBillboardSection[];
  highlights: IBillboardHighlight[];
}

export const DownContent = ({
  sectionContent,
  highlights,
  sections,
}: IDownContentProps) => {
  const {
    getSectionsObserver,
    isLoading,
    sectionsObserverPage,
    isSectionsObserverLastPage,
  } = useBrowsePageService();

  const isAbleToLoadMore =
    !isSectionsObserverLastPage && !isLoading && sectionsObserverPage >= 2;

  return (
    <BillboardPageContent hasHighlights={highlights?.length > 0}>
      <div className="carousel-container">
        {sections?.map((section, index) => (
          <ComponentErrorBoundary key={section?.id}>
            <Suspense
              fallback={getDownContentLoadingSkeleton({
                index,
                section,
                sectionContent,
              })}
            >
              <Carousel section={section} content={sectionContent?.[index]} />
            </Suspense>
          </ComponentErrorBoundary>
        ))}

        {isAbleToLoadMore && <InfinityScroll fetchMore={getSectionsObserver} />}
      </div>
    </BillboardPageContent>
  );
};
